<template>
    <div class="kt-portlet__head">
         <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group  ">
                <label>Denominazione</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Denominazione" type="text" style="width:350px" v-model="search.DENOMINAZIONE.VALUE">
            </div>
            <button class="btn btn-success float-right btn-sm my-2 mt-4" v-on:click="creaPersonaGiuridica()"><i class="fas fa-plus"></i> Nuova Persona Giuridica</button>
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background:#314E8C;color:#fff">
                    <th  style="width:25%"><span >Denominazione</span></th>
                    <th  style="width:15%"><span >Codice Fiscale</span></th>
                    <th  style="width:10%"><span >Partita Iva</span></th>
                    <th  style="width:10%"><span >Indirizzo</span></th>
                    <th  style="width:10%"><span >Contatti</span></th>
                    <th  style="width:20%"><span >Comune > Provincia > Regione</span></th>
                    <th  style="width:10%"><span >Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="personaGiuridica.ID_PERSONA_GIURIDICA"  v-for="personaGiuridica in paginatedList.arr">                        
                    <td  style="width:25%;font-size:16px;font-weight:bold">
                        <i class="fa fa-university"></i>
                        {{personaGiuridica.DENOMINAZIONE != null ? personaGiuridica.DENOMINAZIONE : ''}}
                    </td>
                    <td  style="width:15%">
                        <span  style="font-size:14px">
                             {{ personaGiuridica.CODICE_FISCALE }} 
                        </span>
                    </td>
                    <td  style="width:10%">
                        <span  style="font-size:14px">
                             {{ personaGiuridica.PARTITA_IVA }} 
                        </span>
                    </td>
                    <td  style="width:10%">
                        <span  style="font-size:14px">
                             {{ personaGiuridica.INDIRIZZO + ' ' + personaGiuridica.CAP }} 
                        </span>
                    </td>
                    <td  style="width:10%">
                        <span><i class="fad fa-phone-alt"></i> {{ personaGiuridica.TELEFONO }}</span><br/>
                        <a :href="'mailto:'+personaGiuridica.EMAIL"><span><i class="fad fa-envelope"></i> {{ personaGiuridica.EMAIL }}</span></a>
                    </td>
                    <td  style="width:20%">
                        <strong><i class="fad fa-map-marker-alt fa-fw"></i>{{personaGiuridica.NOME_COMUNE != null? personaGiuridica.NOME_COMUNE + ' > ' : '?' + ' > '}}</strong> {{ personaGiuridica.NOME_PROVINCIA!=null ? personaGiuridica.NOME_PROVINCIA + ' > ' : '?' + ' > '}}  <small>{{ personaGiuridica.NOME_REGIONE!= null ? personaGiuridica.NOME_REGIONE : '?' }}</small>
                    </td>
                    <td  style="width:10%">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button class="btn btn-warning btn-sm mr-2" v-on:click="openPraticheIntestatario(personaGiuridica)" style="background-color:#ffad69"><i class="fad fa-folder-open"></i> Pratiche</button>
                            <button data-toggle="tooltip" data-placement="top" title="Modifica la persona giuridica" class="btn btn-warning btn-sm float-right" v-on:click="modificaPersonaGiuridica(personaGiuridica.ID_PERSONA_GIURIDICA)"><i class="fal fa-pencil"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>

    <div class="modal fade" id="popUpPersonaGiuridica" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #3D519C;">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-university"></i> {{personaGiuridicaSelezionata.DENOMINAZIONE}}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:320px">
                    <PersonaGiuridica  v-model="personaGiuridicaSelezionata"></PersonaGiuridica>       
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaPersonaGiuridica()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>
    <PraticheIntestatario :ref="'praticheIntestatario'" :arrayStati="arrayStati"></PraticheIntestatario>
</template>
<script>

import Pagine from '@/components/utils/Pagine.vue' 
import PersonaGiuridica from '../components/common/PersonaGiuridica.vue';
import PraticheIntestatario from '../components/PraticheIntestatario.vue';



export default {
    name:"PersoneGiuridiche",
    components:{
        Pagine, 
        PersonaGiuridica,
        PraticheIntestatario
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                DENOMINAZIONE:{TYPE:'TEXT',VALUE:''}, 
            },
            personaGiuridicaSelezionata : {},
            arrayPersoneGiuridiche:new Array(),
            arrayStati : new Array(),
        }
    },
    methods: {
        getPersoneGiuridiche : function(){
            global.utils.get('/emmet/persone_giuridiche',{}, (response) => {       
                this.arrayPersoneGiuridiche = response.data           
            });
        },

        getPersonaGiuridica: function(idPersonaGiuridica){            
            global.utils.get('emmet/persona_giuridica',{ID_PERSONA_GIURIDICA: idPersonaGiuridica},(response)=>{
                this.personaGiuridicaSelezionata = utils.clone(response.data); 
            }) 
        },      
        creaPersonaGiuridica : function(){
            this.personaGiuridicaSelezionata = {ID_PERSONA_FISICA:0}
            var modal = utils.openModal('popUpPersonaGiuridica'); 
        },
        modificaPersonaGiuridica : function(idPersonaGiuridica){
            //api persona fisica
            var modal = utils.openModal('popUpPersonaGiuridica');
            this.getPersonaGiuridica(idPersonaGiuridica)
        
        },
        deletePersonaGiuridica : function(idPersonaGiuridica){
            utils.alert.confirm("Sei sicuro di voler la persona giuridica da questa lista?",()=>{
            global.utils.delete('/emmet/persona_giuridica',{ID_PERSONA_GIURIDICA: idPersonaGiuridica},(response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getPersoneGiuridiche();
                }

            });
        },this.$root);  
        },
        salvaPersonaGiuridica : function(){
            //update
            if(this.personaGiuridicaSelezionata.ID_PERSONA_GIURIDICA> 0){
                global.utils.put('/emmet/persona_giuridica',this.personaGiuridicaSelezionata, (response) => {
                    if (response.esito == 0){

                        this.getPersoneGiuridiche();
                        var modal = utils.closeModal('popUpPersonaGiuridica')
                        utils.alert.success(response.messaggio);
                    }
                });
            }else{
            //insert
                global.utils.post('/emmet/persona_giuridica',this.personaGiuridicaSelezionata,(response)=>{
                    if (response.esito == 0){
                        this.getPersoneGiuridiche()
                        var modal = utils.closeModal('popUpPersonaGiuridica')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        openPraticheIntestatario : function(persona){
            this.$refs.praticheIntestatario.praticheIntestatario(persona,2);
        }
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayPersoneGiuridiche,this.search);
            return arr;
        }, 
    },
    created : function(){
        global.utils.get('/emmet/stati',{}, (response) => {       
            this.arrayStati = response.data
            this.getPersoneGiuridiche();
        });        
    },

}


</script>
